import React, { useContext, useState, useEffect } from 'react'
import Loaders from '../../../molecules/Loaders'
import CustomTable from '../../../molecules/CustomTable'
import CustomList from '../../../molecules/CustomList'
import CustomSearch from '../../../molecules/CustomSearch'
import CustomCommonContext from '../../../../../custom/context/common/commonContext'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'
import PrimaryButton from '../../../../../product/components/atoms/PrimaryButton'
import CustomDialog from '../../../organisms/Dialog'
import { mapData } from '../../../../../product/common/components'

const BaseTablePage = (props) => {
    const { alldata_all_dropdown, allLocations, allCategory } =
        useContext(CustomCommonContext)
    const [tableValues, setTableValues] = useState([])
    const arrayValue = props.arrayValue
    const isLoading = props.isLoading
    const searchInfo = props.searchInfo
    const tableBody = props.tableBody

    useEffect(() => {
        let tempArray = []
        let tableValueArray = arrayValue
        tableValueArray
            .filter((data) => (data.active ? data.active === 1 : true))
            .map((item, index) => {
                if (item.name === 'action') {
                    tempArray.push(item)
                } else {
                    let tableValue = {}
                    tableValue.field = item.field
                    tableValue.type = item.type
                    tableValue.sort = item.sort === 1 ? true : false
                    tableValue.filterable = item.filterable ? true : false
                    tableValue.editable = item.editable ? item.editable : false
                    tableValue.filterField = item.filterField
                        ? item.filterField
                        : null
                    tableValue.disablePadding = false
                    tableValue.label = item.label
                    tableValue.sortField = item.sort_field
                        ? item.sort_field
                        : item.sortField
                          ? item.sortField
                          : ''
                    tableValue.class = item.class ? item.class : ''
                    tableValue.tooltipTitle = item.tooltipTitle
                    tableValue.tooltipType = item.tooltipType
                    tableValue.disabled = item.disabled ? true : false
                    tableValue.showIcon = item.showIcon ? item.showIcon : false
                    tableValue.iconUrl = item.iconUrl
                    tableValue.iconAlt = item.iconAlt
                    tableValue.valCondition = item.valCondition
                    tableValue.conditionField = item.conditionField
                    tableValue.condition = item.condition
                    tableValue.conditionValue = item.conditionValue
                    tableValue.firstChild = item.firstChild
                    tableValue.custom = item.custom
                    tableValue.addStarMark = item?.addStarMark
                    tableValue.multipleFields = item.multipleFields
                    tableValue.countryfield = item.countryfield
                    tableValue.dropdownFilterBy = item?.dropdownFilterBy
                    tableValue.dropdownReturnVariable =
                        item?.dropdownReturnVariable

                    tableValue.condition = item.condition
                    tableValue.conditionValue = item.conditionValue
                    tableValue.valueGetter = item.valueGetter
                    tableValue.valueOptions = item.valueOptions

                    if (item.click) {
                        tableValue.click = item.click
                        tableValue.onclick = item.onclick
                        tableValue.clickID = item.clickID
                        tableValue.secondaryClickID = item.secondaryClickID
                        tableValue.clickType = item.clickType
                    }
                    if (item.type === 'imagewithurl') {
                        tableValue.folder = item.folder
                    }
                    if (item.type === 'singleSelect') {
                        if (
                            item.valueOptions &&
                            item?.valueOptions?.length > 0
                        ) {
                            tableValue.valueOptions = item.valueOptions
                        } else if (item.location) {
                            tableValue.valueOptions = allLocations.map(
                                (data) => {
                                    let valueChanged = {}
                                    valueChanged.label = data.name
                                    valueChanged.value = data.id.toString()
                                    return valueChanged
                                }
                            )
                        } else if (
                            global?.customCategory &&
                            item?.field === 'category'
                        ) {
                            tableValue.valueOptions = allCategory.map(
                                (data) => {
                                    let valueChanged = {}
                                    valueChanged.label = data.description
                                    valueChanged.value = data.id.toString()
                                    return valueChanged
                                }
                            )
                        } else {
                            tableValue.valueOptions = alldata_all_dropdown
                                .filter(
                                    (data) =>
                                        data.level == 0 &&
                                        data.variable == item.field
                                )
                                .map((data) => {
                                    let valueChanged = {}
                                    valueChanged.label = data.description
                                    valueChanged.value = data.id.toString()
                                    return valueChanged
                                })
                        }
                    }
                    if (global.enableDataGrid) {
                        if (
                            !tempArray.find(
                                (item) => item.field === tableValue.field
                            )
                        )
                            tempArray.push(tableValue)
                    } else {
                        tempArray.push(tableValue)
                    }
                }
                return true
            })

        setTableValues(tempArray)
    }, [arrayValue])

    return (
        <>
            {searchInfo ? (
                <>
                    <CustomSearch
                        searchInfo={searchInfo}
                        formik={searchInfo.formik}
                        advFilters={props.advFilters}
                        resetForm={props.resetForm}
                        show_dashboard={props.show_dashboard}
                        incudeTimelineFilter={props.incudeTimelineFilter}
                    />
                </>
            ) : null}
            {isLoading ? (
                <Loaders name="table" isLoading={isLoading} />
            ) : props.listView ? (
                <CustomList
                    formik={
                        props.formik
                            ? props.formik.values
                            : searchInfo.formik.values
                    }
                    tableBody={props.tableBody}
                    noLocation={props.noLocation}
                    noauction_image={props.noauction_image}
                    noType={props.noType}
                    tableValues={tableValues}
                    tableActions={props.tableActions}
                    allData={props.allData}
                    changeTableFunction={props.changeTableFunction}
                    selectValues={alldata_all_dropdown}
                    editTableCell={props.editTableCell}
                    ignoreEditArray={props.ignoreEditArray}
                    enableEditTableCell={props.enableEditTableCell}
                    enableColumnEdit={props.enableColumnEdit}
                    dynamicFieldValues={props.dynamicFieldValues}
                    onSelectMultiProducts={props.onSelectMultiProducts}
                    additionalFilterFormik={props.additionalFilterFormik}
                    additionalFilterMapData={props.additionalFilterMapData}
                    additionalFilter={props.additionalFilter}
                    reorder={props.reorder}
                    reorderId={props.reorderId}
                    propertyColumnReOrder={props.propertyColumnReOrder}
                    action={props.action}
                    toggleFullScreenPopup={props.toggleFullScreenPopup}
                    toggleBulkImagePopup={props.toggleBulkImagePopup}
                    fromVariable={props.fromVariable}
                    noShowBid={props.noShowBid}
                    editFunction={props.editFunction}
                />
            ) : (
                <CustomTable
                    formik={
                        props.formik
                            ? props.formik.values
                            : searchInfo.formik.values
                    }
                    tableBody={props.tableBody}
                    tableValues={tableValues}
                    tableActions={props.tableActions}
                    allData={props.allData}
                    changeTableFunction={props.changeTableFunction}
                    selectValues={alldata_all_dropdown}
                    editTableCell={props.editTableCell}
                    ignoreEditArray={props.ignoreEditArray}
                    enableEditTableCell={props.enableEditTableCell}
                    enableColumnEdit={props.enableColumnEdit}
                    dynamicFieldValues={props.dynamicFieldValues}
                    onSelectMultiProducts={props.onSelectMultiProducts}
                    additionalFilterFormik={props.additionalFilterFormik}
                    additionalFilterMapData={props.additionalFilterMapData}
                    additionalFilter={props.additionalFilter}
                    reorder={props.reorder}
                    reorderId={props.reorderId}
                    propertyColumnReOrder={props.propertyColumnReOrder}
                    hideCompactView={props.hideCompactView}
                    fromVariable={props.fromVariable}
                    columnStorageVariable={props.columnStorageVariable}
                    editFunction={props.editFunction}
                    diff_id={props.diff_id}
                />
            )}
        </>
    )
}

BaseTablePage.propTypes = {
    arrayValue: PropTypes.any,
    isLoading: PropTypes.bool.isRequired,
    searchInfo: PropTypes.any.isRequired,
    tableBody: PropTypes.any.isRequired,
    tableActions: PropTypes.any.isRequired,
    allData: PropTypes.any.isRequired,
    changeTableFunction: PropTypes.any.isRequired,
}

export default BaseTablePage
